import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class LTIAssignmentsSharedService {
  constructor(
    private http: HttpClient,
  ) { }

  toggleSideBar(componentRefThis) {
    componentRefThis.learningpathVisible = !componentRefThis.learningpathVisible;
    componentRefThis.learningpathVisibleChange.emit(componentRefThis.learningpathVisible);
  }

  launchActivity(activityItem, componentRefThis) {
    if (componentRefThis.showActivity && activityItem['item-code'] === componentRefThis.selectedItem.activityId) {
      // When the user clicks on the current activity, return
      return;
    }
    componentRefThis.loaderService.showOverlayLoader();
    // Close learningPath on activity change if width lies in the range of mobile screens
    if (window.innerWidth < 576) {
      componentRefThis.learningpathVisible = false;
      componentRefThis.learningpathVisibleChange.emit(componentRefThis.learningpathVisible);
    }
    //Fix for NPB - 258
    if (document.getElementsByClassName("activeClosed").length > 0) {
      document.getElementsByClassName("activeClosed")[0].classList.remove("activeClosed");
    }
    componentRefThis.showActivity = true;
    componentRefThis.showActivityChange.emit(componentRefThis.showActivity);
    let requiredQueryParams = componentRefThis.appHelperService.getRequiredQueryParams(componentRefThis.activatedRoute.snapshot.queryParams, ['ltik']);
    // componentRefThis.router.navigate(["item", activityItem['item-code']], {relativeTo: componentRefThis.activatedRoute, queryParams: requiredQueryParams, ...componentRefThis.ebookAssignmentFlowParams});  
    componentRefThis.router.navigate(["item", activityItem['item-code']], { relativeTo: componentRefThis.activatedRoute, queryParams: requiredQueryParams });
    componentRefThis.loaderService.hideLoader();
  }

  changeCardBgColor(event, componentRefThis) {
    let target = event.target;
    let targetClasses = target.classList;
    // get the card-header element from HTMl markup
    let cardElementClasses = target.parentElement.parentElement.parentElement.classList;
    if (targetClasses.contains("active")) {
      if (targetClasses && targetClasses.contains("collapsed")) {
        cardElementClasses.remove("activeClosed");
      } else {
        cardElementClasses.add("activeClosed");
      }
    }
  }

  startLoader(componentRefThis) {
    componentRefThis.loaderService.showOverlayLoader();
  }

  selectLessonAllItems($event, lessonItem, unit, componentRefThis) {
    if (componentRefThis.gradeActivitySelection && componentRefThis.classmeta.class.isClassEnded) return;
    let totalItems = lessonItem.items.length - lessonItem.itemsDisabled;
    let checkedItems = lessonItem.checkedItems;
    if (!$event.currentTarget.checked || (checkedItems !== 0 && checkedItems !== totalItems)) {
      componentRefThis.markItemsCheckBoxState(false, lessonItem, unit);
      $event.target.checked = false;
      $event.target.indeterminate = false;
    } else {
      if (componentRefThis.isAssignmentJourney || componentRefThis.isCustomLinksJourney) {
        let itemsPresentInLesson = 0;
        lessonItem.items.forEach((item) => {
          if (!componentRefThis.isTestTypeComponent || !item.isDisabled) itemsPresentInLesson++;
        });
        let newAssignmentCount = componentRefThis.assignmentsLOCount + itemsPresentInLesson;

        // Check if the new count exceeds the allowed LO limit
        if (newAssignmentCount <= componentRefThis.assignmentsLOLimitInClass) {
          componentRefThis.assignmentsLOCount = newAssignmentCount;
        } else {
          // If limit exceeded, prevent selection and show a warning
          $event.target.checked = false;
          componentRefThis.assignmentsLOLimitWarningModalButton.nativeElement.click();
          return;
        }
      }

      componentRefThis.markItemsCheckBoxState(true, lessonItem, unit);
      $event.target.checked = true;
      $event.target.indeterminate = false;
    }
  }

  // For selecting all the lessons of a unit
  selectUnitAllLessons($event, unit, componentRefThis) {
    if (componentRefThis.gradeActivitySelection && componentRefThis.classmeta.class.isClassEnded) return;
    let totalItems = unit.totalItems;
    let checkedItems = unit.checkedItems;
    if (!$event.currentTarget.checked || (checkedItems !== 0 && checkedItems !== totalItems)) {
      this.markLessonsCheckBoxState(false, unit, componentRefThis);
      $event.target.checked = false;
      $event.target.indeterminate = false;
    } else {
      this.markLessonsCheckBoxState(true, unit, componentRefThis);
      $event.target.checked = true;
      $event.target.indeterminate = false;
    }
  }

  // For selecting all the units of a product
  selectAllUnitAllLessons($event, componentRefThis) {
    if (componentRefThis.gradeActivitySelection && componentRefThis.classmeta.class.isClassEnded) return;
    let totalItems = componentRefThis.totalItemsInProduct;
    let checkedItems = componentRefThis.noOfCheckedItems;
    if (!$event.currentTarget.checked || (checkedItems !== 0 && checkedItems !== totalItems)) {
      if (componentRefThis.tocFolderDepth === 0) componentRefThis.markItemsCheckBoxState(false, { items: componentRefThis.tocArray }, null);
      else if (componentRefThis.tocFolderDepth === 1) this.markLessonsCheckBoxState(false, { items: componentRefThis.tocArray }, componentRefThis);
      else this.markUnitCheckBoxState(false, componentRefThis);
      $event.target.checked = false;
      $event.target.indeterminate = false;
    } else {
      if (componentRefThis.tocFolderDepth === 0) componentRefThis.markItemsCheckBoxState(true, { items: componentRefThis.tocArray }, null);
      else if (componentRefThis.tocFolderDepth === 1) this.markLessonsCheckBoxState(true, { items: componentRefThis.tocArray }, componentRefThis);
      else this.markUnitCheckBoxState(true, componentRefThis);
      $event.target.checked = true;
      $event.target.indeterminate = false;
    }
  }

  private markLessonsCheckBoxState(valueToBeSet: boolean, unit: any, componentRefThis) {
    for (const lesson of unit.items) {
      componentRefThis.markItemsCheckBoxState(valueToBeSet, lesson, unit);
    }
  }

  private markUnitCheckBoxState(valueToBeSet: boolean, componentRefThis) {
    for (const unit of componentRefThis.tocArray) {
      this.markLessonsCheckBoxState(valueToBeSet, unit, componentRefThis);
    }
  }

}